import { render, staticRenderFns } from "./TemplateMatrix.vue?vue&type=template&id=6e2afa3a&scoped=true&"
import script from "./TemplateMatrix.vue?vue&type=script&lang=ts&"
export * from "./TemplateMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateMatrix.vue?vue&type=style&index=0&id=6e2afa3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2afa3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VSpacer,VToolbar,VToolbarTitle,VTooltip})
